const Action = require("components/abstract/Action");
const Injector = require("../../decorators/Injector");
const PageContext = require("services/PageContext");

@Injector(["data", "store"])
class Clickable extends Action {

    static get defaultProps() {
        return {
            className: '',
            data: null,
            isActive: false,
            byStore: false
        };
    }

    _action = (e) => {

        if(e.target.tagName === 'INPUT'){
            console.log('aborting');
            return false;
        }

        console.log(e, e.target, e.target.tagName);

        super.onAction(this.props.data);
    }

    get id(){
        if(typeof(this.props.data.get) === 'function'){
            return this.props.data.get('id');
        }
        return this.props.data.id;
    }

    get isActive() {
        if (this.props.byStore) {

            if(!this.props.store || !this.props.store.active){
                return false;
            }

            if (PageContext.params[this.props.store.resource] === this.props.store.active.id) {
                return true;
            } else {
                return false;
            }

        }
        return this.props.isActive;
    }

    render() {
        return (
            <div onClick={this._action} className={[this.props.className, this.isActive ? 'active' : ''].join(" ")} >{this.props.children}</div >
        );
    }

}

module.exports = Clickable;